import { onlineManager, useSuspenseQueries } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { queryKeys } from '@/queries/keys'
import {
  getBookingQueryOptions,
  getBookingTransportationQueryOptions,
} from '@/queries/query'
import TripTypePage from '@/pages/make-booking/bus-details/TripType'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/trip-type/',
)({
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(
        getBookingTransportationQueryOptions(params.transportationId),
      )
    }
    return context.queryClient.getQueryData(
      queryKeys.booking.transportation(params.transportationId),
    )
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id, transportationId } = Route.useParams()
  const [
    {
      data: {
        data: { booking },
      },
    },
    {
      data: {
        data: { booked_transportation: transportation },
      },
    },
  ] = useSuspenseQueries({
    queries: [
      getBookingQueryOptions(id),
      getBookingTransportationQueryOptions(transportationId),
    ],
  })
  return <TripTypePage booking={booking} transportation={transportation} />
}
